import { useTranslation } from "react-i18next";
import React, { useState, useReducer, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useTheme } from "../../contexts/ThemeContext";

// Components
import Spinner from "../Components/Spinner";
import ModalSearchVehicle from "./ModalSearchVehicle";

// Services
import { manufacturerService } from "../../Services/manufacturer.service";
import { categoryService } from "../../Services/category.service";
import { modelsService } from "../../Services/models.service";
import { colorService } from "../../Services/color.service";
import { fuelService } from "../../Services/fuel.service";

// Icons
import { AiFillCar, AiOutlineSearch, AiFillSave, AiFillEdit } from "react-icons/ai";
import { TbHandStop } from "react-icons/tb";

import { vehicleService } from "../../Services/vehicle.service";
import ModalRevisePlates from "./ModalRevisePlates";

const filterReducer = (state, event) => {
  if (event.reset) {
    return { plate: "", chassis: "" };
  }
  return {
    ...state,
    [event.name]: event.value,
  };
};

const formReducer = (state, event) => {
  if (event.setter) {
    return event.vehicle;
  }

  if (event.reset) {
    return {
      ManufacturerName: "",
      VehicleCategoryName: "",
      VehicleModelName: "",
      Plate: "",
      Renavam: 0,
      ColorName: "",
      carColorId: 0,
      carColorName: "",
      automakerId: 0,
      chassis: "",
      cityId: 0,
      fuelId: 0,
      fuelTypeName: "",
      id: 0,
      insuranceCompanyId: 0,
      licensePlate: "",
      licensePlateAlias: "",
      licensePlateFalse: "N",
      positioningSituationId: 0,
      Renavam: "1",
      vehicleGroupId: 0,
      vehicleModelId: 0,
      vehicleModelName: "",
      vehicleCategoryId: 0,
      yearManufacture: 0,
      modelYear: 0,
      prefix: "",
      plateAlt: "",
      infoAux: "",
    };
  }



  const { name, value, label, chassisRequired } = event;


  // Mapeamento reverso de nomes com base em IDs
  switch (name) {
    case "licensePlate":
    case "Plate":
      return {
        ...state,
        licensePlate: value,
        Plate: value,
      };

    case "Renavam":
      return {
        ...state,
        renavam: "1",
        Renavam: "1",
      };



    case "plateAlt":
      return {
        ...state,
        prefix: value,
        plateAlt: label,
        chassisRequired: chassisRequired
      };

    case "automakerId":
    case "manufacturerId":
      return {
        ...state,
        [name]: value,
        ManufacturerName: label, // ou buscar nome real se disponível

      };

    case "fuelId":
    case "fuelTypeId":
      return {
        ...state,
        [name]: value,
        fuelTypeName: value,
        fuelTypeName: label, // 👈 aqui pegamos o texto do option
      };

    case "vehicleCategoryId":
      return {
        ...state,
        [name]: value,
        VehicleCategoryName: label,
      };

    case "carColorId":
    case "colorName":
      return {
        ...state,
        [name]: value,
        ColorName: label,
      };

    case "vehicleModelId":
    case "vehicleModelName":
      return {
        ...state,
        [name]: value,
        VehicleModelName: label,
      };



    default:
      return {
        ...state,
        [name]: value,
      };
  }
};



const alertReducer = (state, event) => {
  if (event.reset) {
    return { show: false, message: "", color: "danger" };
  }
  return {
    ...state,
    show: event.show,
    message: event.message,
    color: event.color,
  };
};

// Constants
const _pageTitle = "Cadastro de Veículos";


export default function RegisterVehicle() {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useReducer(formReducer, {});
  const [listManufacturers, setListManufacturers] = useState([]);
  const [listCategories, setListCategories] = useState([]);
  const [listModels, setListModels] = useState([]);
  const [listCores, setListCores] = useState([]);
  const [listFuel, setListFuel] = useState([]);
  const [listPlateAlt, setListPlateAlt] = useState([]);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [filter, setFilter] = useReducer(filterReducer, {});
  const [selectedVehicle, setSelectedVehicle] = useState({});
  const [viewOnly, setViewOnly] = useState(true);
  const [showFields, setShowFields] = useState(false);
  const [loadLists, setLoadLists] = useState(false);
  const [inlineType, setInlineType] = useState('1');
  const [showModal, setShowModal] = useState(false);

  const [alert, setAlert] = useReducer(alertReducer, {
    show: false,
    message: "",
    color: "danger",
  });

  const { isDark } = useTheme();
  const dispatch = useDispatch();
  dispatch({ type: "title", value: _pageTitle });

  const onSearch = () => {
    setAlert({ reset: true });
    if (filter.plate || filter.chassis) {
      setShowSearchModal(true);
    }
  };

  const handleRadioChange = (e) => {
    setInlineType(e.target.value);
    setFormData({
      name: "licensePlate",
      value: ""
    });
  };

  const handleGeneratePlate = async (prefix, chassis) => {

    try {
      const response = await vehicleService.simulatePlate(prefix, chassis);

      if (response) {
        console.log(response);

        setFormData({
          name: "licensePlate",
          value: response.plate
        });
      } else {
        console.log('não encontrado');
      }
    } catch (error) {
      console.error('Erro ao gerar placa:', error);
    }
  };

  const handleFilterChange = (event) => {
    setFilter({
      name: event.target.name,
      value: event.target.value.trim(),
    });
  };

  const handleFormChange = async (event) => {

    if (event.target.name === "yearManufacture") {
      const limit = 4;

      // 👇️ only take first N characters
      setFormData({
        name: event.target.name,
        value: event.target.value.slice(0, limit),
      });
      return;
    }

    let label = "";

    // Só tenta acessar options se for um <select>
    if (event.target.tagName === "SELECT") {
      const selectedIndex = event.target.selectedIndex;
      const selectedOption = event.target.options[selectedIndex];

      if (selectedOption) {
        label = selectedOption.text;
      }
    }

    if (event.target.name === "plateAlt") {

      const selectedItem = listPlateAlt.find(item => item.prefix === event.target.value);

      setFormData({
        name: "licensePlate",
        value: ""
      });

      setFormData({
        name: event.target.name,
        value: event.target.value,
        label: label,
        chassisRequired: selectedItem?.chassisRequired === 'S'
      });
      return;
    }

    if (event.target.name === "carColorId") {

      setFormData({
        name: 'colorName',
        value: event.target.value,
      });

      setFormData({
        name: event.target.name,
        value: event.target.value,
        label: label
      });

      return;
    }

    if (event.target.name === "automakerId") {
      const selectedAutomakerId = event.target.options[event.target.selectedIndex].value;

      if (!selectedAutomakerId) {
        setListModels([]);
        setListCategories([]); // Or fetch all categories again? For now empty seems safer/logical
        setFormData({
          name: event.target.name,
          value: "",
          label: label,
          vehicleCategoryId: 0,
          vehicleModelId: 0
        });
        return;
      }

      setLoadLists(true);

      try {
        const models = await modelsService.findByAutomaker(selectedAutomakerId);
        setListModels(models);

        // Derive categories from models
        const uniqueCategories = [];
        const map = new Map();
        for (const model of models) {
          if (!map.has(model.categoryId)) {
            map.set(model.categoryId, true);
            uniqueCategories.push({
              categoryId: model.categoryId,
              description: model.categoryName
            });
          }
        }
        setListCategories(uniqueCategories);

      } finally {
        setTimeout(() => {
          setLoadLists(false);
        }, 200);
      }

      setFormData({
        name: event.target.name,
        value: selectedAutomakerId,
        label: label,
        vehicleCategoryId: 0, // Reset category
        vehicleModelId: 0 // Reset model
      })

      return;

    }

    if (event.target.name === "vehicleCategoryId") {
      const selectedCategoryId = Number(event.target.value);

      setFormData({
        name: event.target.name,
        value: selectedCategoryId,
        label: label
      });
      return;
    }

    if (event.target.name === "vehicleModelId") {
      const selectedModelId = Number(event.target.value);
      const selectedModel = listModels.find(m => m.vehicleModelId === selectedModelId);

      if (selectedModel) {
        // Check if the model's category is "Nao Informada" or "NAO IDENTIFICADO" (case insensitive)
        const isNaoIdentificado = selectedModel.categoryName &&
          (selectedModel.categoryName.toLowerCase().includes("nao informada") ||
            selectedModel.categoryName.toLowerCase().includes("nao identificado"));

        // First, set the model
        setFormData({
          name: event.target.name,
          value: selectedModelId,
          label: label
        });

        // Then, set the category separately to ensure formReducer handles it correctly
        setTimeout(() => {
          setFormData({
            name: "vehicleCategoryId",
            value: selectedModel.categoryId,
            label: selectedModel.categoryName
          });
        }, 0);

        if (isNaoIdentificado) {
          // If "NAO IDENTIFICADO", regenerate all categories from the automaker's models
          const uniqueCategories = [];
          const map = new Map();
          for (const model of listModels) {
            if (!map.has(model.categoryId)) {
              map.set(model.categoryId, true);
              uniqueCategories.push({
                categoryId: model.categoryId,
                description: model.categoryName
              });
            }
          }
          setListCategories(uniqueCategories);
        } else {
          // If specific category, lock to that category only
          setListCategories([
            {
              categoryId: selectedModel.categoryId,
              description: selectedModel.categoryName
            }
          ]);
        }
      } else {
        setFormData({
          name: event.target.name,
          value: selectedModelId,
          label: label
        });
      }
      return;
    }

    setFormData({
      name: event.target.name,
      value: event.target.value,
      label: label
    })

  };

  const handleSelectVehicle = async (vehicle) => {
    setShowSearchModal(false);
    setViewOnly(false); // Permitir edição
    setShowFields(true);
    
    // Reabilitar campos de busca
    setFilter({ reset: true });

    try {
      const models = await modelsService.list();
      setListModels(models);
    } finally {
      setTimeout(() => {
        setLoadLists(false);
      }, 200);
    }


    // add o id da montadora ao veiculo selecionado
    const montadora = listManufacturers.find(item => item.description === selectedVehicle.manufacturerName);
    if (montadora) {
      vehicle.manufacturerId = montadora.automakerId;
    }

    // add o id do modelo ao veiculo selecionado
    let modelos = [];
    if (montadora) {
      modelos = await modelsService.findByAutomaker(montadora.automakerId);

      // Derive categories from models
      const uniqueCategories = [];
      const map = new Map();
      for (const model of modelos) {
        if (!map.has(model.categoryId)) {
          map.set(model.categoryId, true);
          uniqueCategories.push({
            categoryId: model.categoryId,
            description: model.categoryName
          });
        }
      }
      setListCategories(uniqueCategories);

    } else {
      modelos = await modelsService.list();
      setListCategories([]); // No automaker, no categories derived? Or fetch all? User said "only of selected model".
    }
    setListModels(modelos); // atualiza o estado para reuso depois

    const modelo = modelos.find(item => item.description === selectedVehicle.vehicleModelName);
    if (modelo) {
      vehicle.vehicleModelId = modelo.vehicleModelId;
    }

    setFormData({ setter: true, vehicle });
    setSelectedVehicle(vehicle);

  };

  const handleSelectVehicleRevise = async (vehicle) => {
    setShowModal(false);
    setViewOnly(false);
    setShowFields(true);

    try {
      // Carregar todos os modelos para encontrar o modelo correto
      const allModels = await modelsService.list();
      setListModels(allModels);


      // Mapear os dados do veículo para o formato esperado pelo formulário
      const mappedVehicle = {
        vehicleId: vehicle.vehicleId,
        licensePlate: vehicle.licensePlate,
        chassisCode: vehicle.chassis,
        chassis: vehicle.chassis,
        renavam: vehicle.renavam || "1",
        yearManufacture: vehicle.manufacturingYear || 0,
        manufacturingYear: vehicle.manufacturingYear || 0,
        modelYear: vehicle.modelYear || 0,

        // Cor - garantir que seja número
        carColorId: Number(vehicle.colorId) || 0,
        colorId: Number(vehicle.colorId) || 0,
        colorName: vehicle.colorName || "",
        ColorName: vehicle.colorName || "",

        // Combustível
        fuelId: vehicle.fuelTypeId || 0,
        fuelTypeId: vehicle.fuelTypeId || 0,
        fuelTypeName: vehicle.fuelTypName || "",
        fuelTypName: vehicle.fuelTypName || "",

        // Montadora - buscar ID correto
        manufacturerId: vehicle.manufacturerId || 0,
        automakerId: vehicle.manufacturerId || 0,
        manufacturerName: vehicle.manufacturerName || "",
        ManufacturerName: vehicle.manufacturerName || "",

        // Categoria
        vehicleCategoryId: vehicle.vehicleCategoryId || 0,
        vehicleCategoryName: vehicle.vehicleCategoryName || "",
        VehicleCategoryName: vehicle.vehicleCategoryName || "",

        // Modelo
        vehicleModelId: vehicle.vehicleModelId || 0,
        vehicleModelName: vehicle.vehicleModelName || "",
        VehicleModelName: vehicle.vehicleModelName || "",

        // Outros
        infoCar: vehicle.infoCar || "",
        isActive: vehicle.isActive || "S",
        apiResponse: vehicle.apiResponse || ""
      };

      // Tentar encontrar a cor pelo nome se o ID não estiver disponível
      if ((!mappedVehicle.carColorId || mappedVehicle.carColorId === 0) && mappedVehicle.colorName) {
        const cor = listCores.find(
          item => item.description.toUpperCase() === mappedVehicle.colorName.toUpperCase()
        );
        if (cor) {
          mappedVehicle.carColorId = Number(cor.colorId);
          mappedVehicle.colorId = Number(cor.colorId);
        }
      }

      // Tentar encontrar a montadora pelo nome se o ID não estiver disponível
      if ((!mappedVehicle.automakerId || mappedVehicle.automakerId === 0) && mappedVehicle.manufacturerName) {
        const montadora = listManufacturers.find(
          item => item.description.toUpperCase() === mappedVehicle.manufacturerName.toUpperCase()
        );
        if (montadora) {
          mappedVehicle.automakerId = montadora.automakerId;
          mappedVehicle.manufacturerId = montadora.automakerId;
        }
      }

      // Se temos automakerId, carregar os modelos específicos dessa montadora
      if (mappedVehicle.automakerId && mappedVehicle.automakerId > 0) {
        setLoadLists(true);
        try {
          const models = await modelsService.findByAutomaker(mappedVehicle.automakerId);
          setListModels(models);

          // Derive categories from models
          const uniqueCategories = [];
          const map = new Map();
          for (const model of models) {
            if (!map.has(model.categoryId)) {
              map.set(model.categoryId, true);
              uniqueCategories.push({
                categoryId: model.categoryId,
                description: model.categoryName
              });
            }
          }
          setListCategories(uniqueCategories);

          // Tentar encontrar o modelo pelo nome se o ID não estiver disponível
          if ((!mappedVehicle.vehicleModelId || mappedVehicle.vehicleModelId === 0) && mappedVehicle.vehicleModelName) {
            const modelo = models.find(
              item => item.description.toUpperCase() === mappedVehicle.vehicleModelName.toUpperCase()
            );
            if (modelo) {
              mappedVehicle.vehicleModelId = modelo.vehicleModelId;
            }
          }
        } finally {
          setTimeout(() => {
            setLoadLists(false);
          }, 200);
        }
      }

      setFormData({ setter: true, vehicle: mappedVehicle });
      setSelectedVehicle(mappedVehicle);
    } catch (error) {
      console.error('Erro ao processar dados do veículo:', error);
    }
  };

  const onNew = () => {
    setSelectedVehicle({});
    setViewOnly(false);
    setShowFields(true);
    setFormData({ reset: true });
    setAlert({ reset: true });
    setListModels([]);
    setListCategories([]);
  };

  const onCancel = () => {
    setViewOnly(true);
    setShowFields(false);
    setFormData({
      reset: true,
    });
    setAlert({
      reset: true,
    });
  };

  const onSave = async () => {

    setAlert({ reset: true });

    try {
      setIsLoading(true);

      if (!formData.licensePlate) { setAlert({ show: true, message: "Forneça a placa!", color: "warning" }); return; }
      if (!formData.chassisCode && !formData.chassis) { setAlert({ show: true, message: "Forneça o chassis!", color: "warning" }); return; }
      if (formData.carColorId === 0 && formData.colorId === 0) { setAlert({ show: true, message: "Forneça a cor!", color: "warning" }); return; }
      if (formData.automakerId === 0 && formData.manufacturerId === 0) { setAlert({ show: true, message: "Forneça a montadora!", color: "warning" }); return; }
      if (formData.vehicleCategoryId === 0 && formData.vehicleCategoryName === "") { setAlert({ show: true, message: "Forneça a categoria!", color: "warning" }); return; }
      if (formData.vehicleModelId === 0 && formData.vehicleModelName === "") { setAlert({ show: true, message: "Forneça o modelo!", color: "warning" }); return; }
      if (!formData.fuelId && formData.fuelTypeName === "") { setAlert({ show: true, message: "Forneça o combustível!", color: "warning" }); return; }
      if (!formData.yearManufacture && !formData.manufacturingYear) { setAlert({ show: true, message: "Forneça o ano de fabricação!", color: "warning" }); return; }
      if (!formData.modelYear) { setAlert({ show: true, message: "Forneça o ano do modelo!", color: "warning" }); return; }

      const payload = {
        manufacturerName: formData.ManufacturerName || formData.manufacturerName || "",
        vehicleCategoryName: formData.VehicleCategoryName || formData.vehicleCategoryName || "",
        vehicleModelName: formData.VehicleModelName || formData.vehicleModelName || "",
        fipeCode: "",
        plate: formData.licensePlate || "",
        chassis: formData.chassisCode || formData.chassis || "",
        renavam: formData.renavam || "0",
        manufactureYear: Number(formData.yearManufacture) || 0,
        modelYear: Number(formData.modelYear) || 0,
        colorName: formData.colorName || "",
        fuelTypeName: formData.fuelTypeName || formData.fuelTypName || "",
        infoCar: formData.infoCar || "",
        isActive: formData.isActive || "S",
        apiResponse: formData.apiResponse || ""
      };

      let response;
      let isUpdate = false;

      if (formData?.vehicleId && formData.vehicleId > 0) {
        response = await vehicleService.update(payload, formData.vehicleId);
        isUpdate = true;
      } else {
        response = await vehicleService.create(payload);
        isUpdate = false;
      }

      if (response?.status === 200 || response?.status === 201) {
        setAlert({ show: true, message: isUpdate ? "Veículo atualizado com sucesso!" : "Veículo salvo com sucesso!", color: "success" });
        setViewOnly(true);
      } else if (response?.data) {
        setAlert({ show: true, message: response.data[0].message, color: "warning" });
      } else {
        setAlert({ show: true, message: isUpdate ? "Erro ao atualizar o veículo." : "Erro ao salvar o veículo.", color: "danger" });
      }
    } catch (error) {
      setAlert({ show: true, message: "Não foi possível processar a operação. Tente novamente mais tarde.", color: "danger" });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    (async () => {

      try {
        setLoadLists(true);
        setListManufacturers(await manufacturerService.list());
        // setListCategories(await categoryService.list()); // Removed as per requirement
        setListCores(await colorService.list());
        setListFuel(await fuelService.list());
        if (inlineType === '3') {
          setListPlateAlt(await vehicleService.byPlateCode())
        }
      } finally {
        setTimeout(() => {
          setLoadLists(false);
        }, 200);
      }
    })();
  }, [inlineType]);

  return (
    <>
      {/* SVG Icons for alerts */}
      <svg xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }}>
        <defs>
          <symbol id="exclamation-triangle-fill" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
          </symbol>
        </defs>
      </svg>

      <div className='container-xxl flex-grow-1 container-p-y'>

        {isLoading ? <Spinner /> : ""}

        <ModalSearchVehicle
          show={showSearchModal}
          handleClose={setShowSearchModal}
          filter={filter}
          handleSelectVehicle={handleSelectVehicle}
        />

        <ModalRevisePlates
          show={showModal}
          handleClose={setShowModal}
          handleSelectVehicle={handleSelectVehicleRevise}
        />

        {/* <!--Busca --> */}
        <div className='row'>
          <h5>Preencha os campos para buscar o veículo ou crie um novo</h5>
          <div className='row'>
            <div className='mb-3 col-md-2'>
              <div className='mb-3'>
                <div className='input-group'>
                  <span
                    className='input-group-text'
                    style={isDark ? {
                      backgroundColor: 'var(--bg-tertiary)',
                      color: 'var(--text-primary)',
                      borderColor: 'var(--border-primary)'
                    } : {
                      backgroundColor: 'var(--theme-primary)',
                      color: 'var(--text-inverse)',
                      borderColor: 'var(--theme-primary)'
                    }}
                  >
                    Placa
                  </span>
                  <input
                    type='text'
                    className='form-control'
                    aria-label='Placa'
                    aria-describedby='Placa'
                    name='plate'
                    value={filter.plate || ''}
                    onChange={handleFilterChange}
                    style={{
                      backgroundColor: isDark ? 'var(--bg-primary)' : '#fff',
                      color: isDark ? 'var(--text-primary)' : '#333',
                      borderColor: isDark ? 'var(--border-primary)' : '#d9dee3'
                    }}
                  />
                </div>
              </div>
            </div>


            <div className='mb-2 col-md-3 col-lg-4'>
              <div className='d-flex'>

                <div style={{ paddingRight: "5px" }}>
                  <button
                    type='button'
                    className='btn btn-primary'
                    onClick={() => onSearch()}>
                    <AiOutlineSearch className='icon-in-button' />
                    Buscar
                  </button>
                </div>

                <div>
                  <button
                    type='button'
                    className='btn btn-primary'
                    onClick={onNew}>
                    <AiFillCar className='icon-in-button' />
                    &nbsp; Novo
                  </button>
                </div>

                <div style={{ paddingLeft: "5px" }}>
                  <button
                    type='button'
                    className='btn btn-primary'
                    onClick={() => setShowModal(true)}>
                    <TbHandStop className='icon-in-button' />
                    &nbsp; Revisar placas
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>

        {showFields ? (
          <div className='row'>
            <h4 className='fw-bold py-3 mb-4'>
              <span className='text-muted fw-light'>Dados do veículo </span>
            </h4>
            {selectedVehicle.vehicleModelName ? (
              <>
                <span>
                  <strong>Veículo selecionado: </strong>
                  <span className='badge bg-label-primary'>
                    {selectedVehicle.vehicleModelName}
                  </span>
                </span>
              </>
            ) : (
              ""
            )}
            {alert?.show ? (
              <div
                className={`alert alert-${alert.color} alert-dismissible fade show d-flex align-items-center`}
                role='alert'
                style={{
                  marginTop: '10px',
                  backgroundColor: '#fff3cd !important',
                  borderColor: '#ffecb5 !important',
                  color: '#664d03 !important'
                }}>
                <svg className="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Warning:">
                  <use xlinkHref="#exclamation-triangle-fill" />
                </svg>
                <div className="flex-grow-1">
                  {alert?.message}
                </div>
                <button
                  type='button'
                  className='btn-close'
                  data-bs-dismiss='alert'
                  onClick={() => setAlert({ show: false, message: "" })}
                  aria-label='Close'>
                </button>
              </div>
            ) : (
              ""
            )}

            {loadLists ? (
              <>
                <div className='spinner-grow text-primary' role='status'></div>
                <span className='text-primary'>Carregando listas...</span>
              </>
            ) : (
              ""
            )}
            {/* Checkboxes */}
            {!viewOnly ? (
              <div className='row align-items-center mb-3' style={{ flexWrap: 'nowrap' }}>
                <div className='col-auto'>
                  <div className='form-check form-check-inline me-3'>
                    <input
                      className='form-check-input'
                      type='radio'
                      name='inlineTypes'
                      id='type1'
                      value='1'
                      checked={inlineType === '1'}
                      onChange={handleRadioChange}
                      style={{
                        accentColor: '#00B085'
                      }}
                    />
                    <label
                      className='form-check-label'
                      htmlFor='type1'
                      style={{
                        color: isDark ? 'var(--text-primary)' : '#333'
                      }}
                    >
                      Veículo
                    </label>
                  </div>
                </div>

                <div className='col-auto'>
                  <div className='form-check form-check-inline'>
                    <input
                      className='form-check-input'
                      type='radio'
                      name='inlineTypes'
                      id='type3'
                      value='3'
                      checked={inlineType === '3'}
                      onChange={handleRadioChange}
                      style={{
                        accentColor: '#00B085'
                      }}
                    />
                    <label
                      className='form-check-label'
                      htmlFor='type3'
                      style={{
                        color: isDark ? 'var(--text-primary)' : '#333'
                      }}
                    >
                      Placa alternativa
                    </label>
                  </div>
                </div>

                {/* Campos adicionais (visíveis apenas se inlineType === '3') */}
                {inlineType === '3' && (
                  <>
                    {/* Campo Placa Alternativa */}
                    <div className='col-auto d-flex align-items-center'>
                      <select
                        name='plateAlt'
                        className='form-control'
                        tabIndex={4}
                        disabled={viewOnly}
                        value={formData.prefix ?? ""}
                        onChange={async (e) => await handleFormChange(e)}
                        style={{
                          backgroundColor: isDark ? 'var(--bg-primary)' : '#fff',
                          color: isDark ? 'var(--text-primary)' : '#333',
                          borderColor: isDark ? 'var(--border-primary)' : '#d9dee3'
                        }}
                      >
                        <option value=''>-- Placa Alternativa --</option>
                        {listPlateAlt &&
                          listPlateAlt.map((item, index) => (
                            <option key={index} value={item.prefix}>
                              {item.plateCode}
                            </option>
                          ))}
                      </select>
                    </div>

                    {/* Campo Informação Auxiliar */}
                    {
                      formData.chassisRequired && (
                        <div className='col-md-4 d-flex align-items-center'>
                          <input
                            type='text'
                            className='form-control'
                            placeholder='(4 últimos dígitos do chassi)'
                            name='infoAux'
                            id='infoAux'
                            tabIndex={2}
                            disabled={viewOnly}
                            value={formData.infoAux ?? ''}
                            onChange={handleFormChange}
                            style={{
                              backgroundColor: isDark ? 'var(--bg-primary)' : '#fff',
                              color: isDark ? 'var(--text-primary)' : '#333',
                              borderColor: isDark ? 'var(--border-primary)' : '#d9dee3'
                            }}
                          />
                        </div>

                      )
                    }

                    {/* Botão */}
                    <div className='col-auto d-flex align-items-center'>
                      <button
                        type='button'
                        className='btn btn-primary'
                        disabled={!formData.prefix} // desabilita se prefix for vazio
                        onClick={() => handleGeneratePlate(formData.prefix, formData.infoAux)}
                      >
                        <TbHandStop className='icon-in-button' />
                        &nbsp; Gerar placa
                      </button>
                    </div>
                  </>
                )}
              </div>



            ) : (
              ""
            )}
            <div className='row py-3'>
              {/* Card esquerda */}
              <div className='col-4'>
                <div className='row mb-3'>
                  <label
                    className='col-sm-4 col-form-label'
                    htmlFor='licensePlate'>
                    Placa
                  </label>
                  <div className='col-sm-8'>
                    <input
                      type='text'
                      className='form-control'
                      placeholder='Placa'
                      name='licensePlate'
                      tabIndex={1}
                      disabled={viewOnly || formData.prefix}
                      value={formData.licensePlate ?? ""}
                      onChange={handleFormChange}
                      style={{
                        backgroundColor: isDark ? 'var(--bg-primary)' : '#fff',
                        color: isDark ? 'var(--text-primary)' : '#333',
                        borderColor: isDark ? 'var(--border-primary)' : '#d9dee3'
                      }}
                    />
                  </div>
                </div>

                <div className='row mb-3'>
                  <label
                    className='col-sm-4 col-form-label'
                    htmlFor='automakerId'>
                    Montadora
                  </label>
                  <div className='col-sm-8'>
                    <select
                      name='automakerId'
                      className='form-control'
                      tabIndex={4}
                      disabled={viewOnly}
                      value={formData.automakerId ?? formData.manufacturerId ?? ""}
                      onChange={async (e) => await handleFormChange(e)}
                      style={{
                        backgroundColor: isDark ? 'var(--bg-primary)' : '#fff',
                        color: isDark ? 'var(--text-primary)' : '#333',
                        borderColor: isDark ? 'var(--border-primary)' : '#d9dee3'
                      }}>
                      <option value=''>-- Montadora --</option>
                      {listManufacturers &&
                        listManufacturers.map((item, index) => (
                          <option key={index} value={item.automakerId}>
                            {item.description}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className='row mb-3'>
                  <label className='col-sm-4 col-form-label' htmlFor='fuelId'>
                    Combustível
                  </label>
                  <div className='col-sm-8'>
                    <select
                      name='fuelId'
                      className='form-control'
                      disabled={viewOnly}
                      tabIndex={7}
                      value={formData.fuelId ?? formData.fuelTypeId ?? "Não informado"}
                      onChange={handleFormChange}
                      style={{
                        backgroundColor: isDark ? 'var(--bg-primary)' : '#fff',
                        color: isDark ? 'var(--text-primary)' : '#333',
                        borderColor: isDark ? 'var(--border-primary)' : '#d9dee3'
                      }}>
                      <option value=''>-- Combustível --</option>
                      {listFuel &&
                        listFuel.map((item, index) => (
                          <option key={index} value={item.fuelId}>
                            {item.description}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* Card central */}
              <div className='col-4'>
                <div className='row mb-3'>
                  <label
                    className='col-sm-4 col-form-label'
                    htmlFor='chassisCode'>
                    Chassi
                  </label>
                  <div className='col-sm-8'>
                    <input
                      type='text'
                      className='form-control'
                      name='chassisCode'
                      placeholder='Chassis'
                      tabIndex={2}
                      disabled={viewOnly}
                      value={formData.chassisCode ?? formData.chassis}
                      onChange={handleFormChange}
                      style={{
                        backgroundColor: isDark ? 'var(--bg-primary)' : '#fff',
                        color: isDark ? 'var(--text-primary)' : '#333',
                        borderColor: isDark ? 'var(--border-primary)' : '#d9dee3'
                      }}
                    />
                  </div>
                </div>

                <div className='row mb-3'>
                  <label
                    className='col-sm-4 col-form-label'
                    htmlFor='vehicleModelId'>
                    Modelo
                  </label>
                  <div className='col-sm-8'>
                    <select
                      name='vehicleModelId'
                      className='form-control'
                      tabIndex={6}
                      disabled={viewOnly}
                      value={formData.vehicleModelId ?? formData.vehicleModelName ?? ""}
                      onChange={handleFormChange}
                      style={{
                        backgroundColor: isDark ? 'var(--bg-primary)' : '#fff',
                        color: isDark ? 'var(--text-primary)' : '#333',
                        borderColor: isDark ? 'var(--border-primary)' : '#d9dee3'
                      }}>
                      <option value=''>-- Modelo --</option>
                      {Array.isArray(listModels) &&
                        listModels.map((item, index) => (
                          <option key={index} value={item.vehicleModelId}>
                            {item.description}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>



                <div className='row mb-3'>
                  <label
                    className='col-sm-4 col-form-label'
                    htmlFor='yearManufacture'>
                    Ano fabricação
                  </label>
                  <div className='col-sm-8'>
                    <input
                      type='number'
                      className='form-control'
                      name='yearManufacture'
                      tabIndex={8}
                      maxLength={4}
                      disabled={viewOnly}
                      onChange={handleFormChange}
                      value={formData.yearManufacture ?? formData.manufacturingYear ?? "Não informado"}
                      placeholder='Ano'
                      style={{
                        backgroundColor: isDark ? 'var(--bg-primary)' : '#fff',
                        color: isDark ? 'var(--text-primary)' : '#333',
                        borderColor: isDark ? 'var(--border-primary)' : '#d9dee3'
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Card direita */}
              <div className='col-4'>
                <div className='row mb-3'>
                  <label
                    className='col-sm-4 col-form-label'
                    htmlFor='carColorId'>
                    Cor
                  </label>
                  <div className='col-sm-8'>
                    <select
                      name='carColorId'
                      tabIndex={3}
                      className='form-control'
                      disabled={viewOnly}
                      value={formData.carColorId ?? formData.colorId ?? ""}
                      onChange={handleFormChange}
                      style={{
                        backgroundColor: isDark ? 'var(--bg-primary)' : '#fff',
                        color: isDark ? 'var(--text-primary)' : '#333',
                        borderColor: isDark ? 'var(--border-primary)' : '#d9dee3'
                      }}>
                      <option value=''>-- Cor --</option>
                      {listCores &&
                        listCores.map((item, index) => (
                          <option key={index} value={item.colorId}>
                            {item.description}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className='row mb-3'>
                  <label
                    className='col-sm-4 col-form-label'
                    htmlFor='vehicleCategoryId'>
                    Categoria
                  </label>
                  <div className='col-sm-8'>
                    <select
                      name='vehicleCategoryId'
                      className='form-control'
                      disabled={viewOnly || (listCategories.length === 1 && listCategories[0]?.description && !listCategories[0].description.toLowerCase().includes("nao informada") && !listCategories[0].description.toLowerCase().includes("nao identificado"))}
                      tabIndex={5}
                      onChange={handleFormChange}
                      value={formData.vehicleCategoryId ?? ""}
                      style={{
                        backgroundColor: isDark ? 'var(--bg-primary)' : '#fff',
                        color: isDark ? 'var(--text-primary)' : '#333',
                        borderColor: isDark ? 'var(--border-primary)' : '#d9dee3'
                      }}>
                      <option value=''>-- Categoria --</option>
                      {listCategories &&
                        listCategories.map((item, index) => (
                          <option key={index} value={item.categoryId}>
                            {item.description}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>



                <div className='row mb-3'>
                  <label
                    className='col-sm-4 col-form-label'
                    htmlFor='modelYear'>
                    Ano Modelo
                  </label>
                  <div className='col-sm-8'>
                    <input
                      type='number'
                      className='form-control'
                      name='modelYear'
                      tabIndex={9}
                      maxLength={6}
                      disabled={viewOnly}
                      onChange={handleFormChange}
                      value={formData.modelYear ?? ""}
                      placeholder='Ano'
                      style={{
                        backgroundColor: isDark ? 'var(--bg-primary)' : '#fff',
                        color: isDark ? 'var(--text-primary)' : '#333',
                        borderColor: isDark ? 'var(--border-primary)' : '#d9dee3'
                      }}
                    />
                  </div>
                </div>

                {/* <div className='row mb-3'>
                  <label
                    className='col-sm-4 col-form-label'
                    htmlFor='basic-default-name'>
                    Tabela FIPE
                  </label>
                  <div className='col-sm-8'>
                    <span className='badge bg-danger'>NÃO OK</span>
                    <span className='badge bg-success'>OK</span>
                  </div>
                </div> */}
              </div>
            </div>
            <div className='mt-2'>
              {!viewOnly ? (
                <button
                  type='button'
                  tabIndex={10}
                  className='btn btn-primary me-2'
                  onClick={async () => onSave()}>
                  <AiFillSave className='icon-in-button' />
                  &nbsp; Salvar Veículo
                </button>
              ) : (
                <button
                  type='button'
                  className='btn btn-warning me-2'
                  onClick={() => setViewOnly(false)}>
                  <AiFillEdit className='icon-in-button' />
                  &nbsp; Editar Veículo
                </button>
              )}

              <button
                type='reset'
                className='btn btn-outline-secondary'
                tabIndex={11}
                onClick={onCancel}>
                Cancelar
              </button>
            </div>
          </div>
        ) : (
          ""
        )}
      </div >
    </>
  );
}